/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Add_ExerciseInputs */

const en_us2_workout_add_exercise = /** @type {(inputs: Workout_Add_ExerciseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add exercise`)
};

const pt_br2_workout_add_exercise = /** @type {(inputs: Workout_Add_ExerciseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar exercício`)
};

const es_419_workout_add_exercise = /** @type {(inputs: Workout_Add_ExerciseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar ejercicio`)
};

const pt_pt2_workout_add_exercise = /** @type {(inputs: Workout_Add_ExerciseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar exercício`)
};

const fr_fr2_workout_add_exercise = /** @type {(inputs: Workout_Add_ExerciseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter un exercice`)
};

const de_de2_workout_add_exercise = /** @type {(inputs: Workout_Add_ExerciseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übung hinzufügen`)
};

const it_it2_workout_add_exercise = /** @type {(inputs: Workout_Add_ExerciseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi esercizio`)
};

/**
* | output |
* | --- |
* | "Add exercise" |
*
* @param {Workout_Add_ExerciseInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_add_exercise = /** @type {((inputs?: Workout_Add_ExerciseInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Add_ExerciseInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_add_exercise(inputs)
	if (locale === "es-419") return es_419_workout_add_exercise(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_add_exercise(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_add_exercise(inputs)
	if (locale === "de-DE") return de_de2_workout_add_exercise(inputs)
	if (locale === "it-IT") return it_it2_workout_add_exercise(inputs)
	return en_us2_workout_add_exercise(inputs)
});
export { workout_add_exercise as "workout.add_exercise" }